import { localStorageService } from "@entrilia/shared/services/storage";

export type ArtifactsView = "tiles" | "list";

export type ArtifactsTileSort = "modified" | "name";

const VIEW_STORAGE_KEY = "AI_DASHBOARDS_VIEW";

const TILE_SORT_STORAGE_KEY = "AI_DASHBOARDS_TILE_SORT";

export const readArtifactsView = (): ArtifactsView =>
  localStorageService.getItem<ArtifactsView>(VIEW_STORAGE_KEY) === "list" ? "list" : "tiles";

export const saveArtifactsView = (view: ArtifactsView): void => localStorageService.setItem(VIEW_STORAGE_KEY, view);

export const readArtifactsTileSort = (): ArtifactsTileSort =>
  localStorageService.getItem<ArtifactsTileSort>(TILE_SORT_STORAGE_KEY) === "name" ? "name" : "modified";

export const saveArtifactsTileSort = (sort: ArtifactsTileSort): void =>
  localStorageService.setItem(TILE_SORT_STORAGE_KEY, sort);
